import React from 'react';

const Popups = () => (
  <div className="p-6">
    <h2 className="text-2xl font-bold mb-2">Popups</h2>
    <p className="text-gray-600">This is the Popups page.</p>
  </div>
);

export default Popups;
